export function useWidth(
  attrWidth: number | null | string,
  defaultWidth: number,
  smallMedia: boolean,
  alignment: string,
  containerSize: number
) {
  containerSize = containerSize ?? Infinity;
  attrWidth = attrWidth === '' ? null : attrWidth;

  let width = attrWidth ?? defaultWidth;
  let maxWidth = +defaultWidth;
  width = +width;

  if (smallMedia) {
    maxWidth = 212;
  }

  if (alignment !== 'center') {
    width = Math.min(defaultWidth / 3, +(attrWidth ?? defaultWidth));
    if (defaultWidth > containerSize) {
      width = Math.min(containerSize / 3, +(attrWidth ?? defaultWidth));
    }
    maxWidth = defaultWidth / 3;
  }

  // Keep within bounds
  if (width > containerSize) {
    width = containerSize - 32;
  }

  width = parseInt(`${width}`);

  return { maxWidth, width };
}
